<template>
    <Row type="flex">
        <Col>
            <template v-if="!dataTable.manageSelect || dataTable.manageSelect.force">
                <Dropdown v-if="managesComputed.length > 0" class="ml-2">
                    <Button size="small">
                        <span>{{ $t("button.manage") }}</span>
                        <CIcon file="caret-down.svg"></CIcon>
                    </Button>
                    <template v-slot:overlay>
                        <Menu>
                            <template v-for="(manage, index) in managesComputed" :key="index">
                                <MenuItem @click="() => onClickManage({ props, manage })">
                                    <component v-if="manage.icon" :is="manage.icon"></component>
                                    <span v-if="manage.text">{{ manage.text() }}</span>
                                </MenuItem>
                            </template>
                        </Menu>
                    </template>
                </Dropdown>
            </template>
            <template v-if="dataTable.manageSelect">
                <Button v-if="!dataTable.manageSelect.force" size="small" @click="() => onClickManageCancel({ props })" class="d-inline ml-2">
                    <CIcon file="cancel.svg"></CIcon>
                    <span>{{ $t("button.cancel") }}</span>
                </Button>
                <Button
                    class="d-inline ml-2"
                    size="small"
                    v-bind="dataTable.manageSelect.buttonProp"
                    v-if="!dataTable.manageSelect.autoOk"
                    @click="() => onClickManageOk({ props })"
                >
                    <component v-if="dataTable.manageSelect.icon" :is="dataTable.manageSelect.icon"></component>
                    <span v-if="dataTable.manageSelect.text">{{ dataTable.manageSelect.text() }}</span>
                </Button>
            </template>
            <template v-if="type === 'top'">
                <template v-for="(manage, index) in manageExtras" :key="index">
                    <div v-if="manage.visible?.()" class="d-inline ml-2">
                        <component :is="manage.render"></component>
                    </div>
                </template>
                <Button class="d-inline ml-2 btn-success" @click="() => emit('refresh')" v-if="canRefresh" size="small">
                    <CIcon file="refresh.svg"></CIcon>
                </Button>
            </template>
        </Col>
        <Col class="ml-auto">
            <Pagination v-if="pagination" v-bind="pagination"></Pagination>
        </Col>
    </Row>
</template>

<script>
import { computed, defineAsyncComponent, defineComponent } from "vue";
import { Row, Col, Dropdown, Button, Menu, Pagination } from "ant-design-vue";
import { onClickManage, onClickManageCancel, onClickManageOk, getManages } from "./operator-and-pagination.logic";

export default defineComponent({
    components: {
        Row,
        Col,
        Dropdown,
        Button,
        Pagination,
        Menu,
        MenuItem: Menu.Item,
        CIcon: defineAsyncComponent(() => import("../icon/CIcon"))
    },
    props: {
        propsTable: {},
        dataTable: {},
        refsTable: {},
        type: {},
        pagination: {},
        manages: {},
        manageExtras: {},
        canRefresh: {}
    },
    emits: ["refresh"],
    setup(props, { emit }) {
        const managesComputed = computed(() => getManages({ props }));
        return { props, emit, onClickManage, onClickManageCancel, onClickManageOk, managesComputed };
    }
});
</script>
